<mon-page-header header="Worker queue" [monIcon]="['WORKER_QUEUE', 'ICON']"></mon-page-header>

<a [href]="this.path" target="_blank" aria-describedby="linkOpensInNewTab" class="btn btn-secondary" data-test="open-worker-queue-button">Open worker queue</a>

